import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import FleetDashboard from './components/FleetDashboard'
import CVSFleetDashboard from './components/CVSFleetDashboard'
import MacStyleFleetDashboard from './components/MacStyleFleetDashboard'
import CompleteFleetDashboard from './components/CompleteFleetDashboard'
import MissionDashboard from './components/MissionDashboard'
import LoginPage from './components/LoginPage'
import InvitationAcceptancePage from './components/InvitationAcceptancePage'
import {
  ForgotPasswordPage,
  NewsletterPreferencesPage,
  ResetPasswordPage,
  VerifyEmailPage
} from './components/AccountCommunicationPages'
import ProtectedRoute from './components/ProtectedRoute'
import { VehicleProvider } from './contexts/VehicleContext'
import { AuthProvider } from './contexts/AuthContext'
import { SettingsProvider } from './contexts/SettingsContext'

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <VehicleProvider>
          <div className="App">
            <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/invite/:token" element={<InvitationAcceptancePage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
            <Route path="/newsletter/preferences" element={<NewsletterPreferencesPage />} />
            <Route path="/newsletter/preferences/:token" element={<NewsletterPreferencesPage />} />
            <Route path="/unsubscribe" element={<NewsletterPreferencesPage />} />
            
            {/* Protected routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <CompleteFleetDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <CompleteFleetDashboard />
              </ProtectedRoute>
            } />
            <Route path="/complete" element={
              <ProtectedRoute>
                <CompleteFleetDashboard />
              </ProtectedRoute>
            } />
            
            {/* Mission Control route */}
            <Route path="/missions" element={
              <ProtectedRoute requiredCapability="missions.read">
                <div className="h-screen bg-gray-100">
                  <MissionDashboard />
                </div>
              </ProtectedRoute>
            } />
            
            {/* Legacy routes (protected) */}
            <Route path="/mac" element={
              <ProtectedRoute>
                <MacStyleFleetDashboard />
              </ProtectedRoute>
            } />
            <Route path="/old" element={
              <ProtectedRoute>
                <CVSFleetDashboard />
              </ProtectedRoute>
            } />
            <Route path="/legacy" element={
              <ProtectedRoute>
                <FleetDashboard />
              </ProtectedRoute>
            } />
            
            {/* Catch all - redirect to dashboard */}
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </VehicleProvider>
      </SettingsProvider>
    </AuthProvider>
  )
}

export default App
